<template>
  <div class="life-amount flex_wrap">
    <div v-for="(item, index) in list" class="life-amount-item flex_center"
    :class="{ 'amount-active': modelValue === item }"
    :style="{
      marginBottom: (index + 1) < list.length - 1 ? marginBottom: 0,
      fontSize: size,
      height
    }"
    @click="amountChange(item)">
      {{item}}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: {
        type: Array,
        default: () => []
      },
      modelValue: {
        type: [Number, String]
      },
      size: {
        type: String,
        default: '24px'
      },
      height: {
        type: String,
        default: '36px'
      },
      marginBottom: {
        type: String,
        default: '12px'
      }
    },
    model: {
      prop: 'modelValue',
      event: 'change'
    },
    methods: {
      amountChange(item) {
        if (this.modelValue === item) return this.$emit('change', '')
        this.$emit('change', item)
      }
    }
  }
</script>

<style lang="less" scoped>
  .life-amount {
    .life-amount-item {
      margin-right: 16px;
      width: calc((100% - 16px) / 2);
      // height: 36px;
      font-family: Poppins;
      // font-size: 24px;
      font-weight: 600;
      color: #8C8E8D;
      background: rgb(248, 248, 250);
      border: 0.5px solid rgb(226, 227, 228);
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 5px;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    .amount-active {
      color: #fff !important;
      background: linear-gradient(180.00deg, #ED3A42, #A3181F 100%) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/life-amount.vue